
import { Component, Vue, Watch } from "vue-property-decorator";
import concejoMunicipalService from "@/services/concejo-municipal.service";
import menuService from "@/services/menu.service";
import MobileSectionStrip from "@/components/Common/Web/MobileSectionStrip.vue";

@Component({
  components: {
    MobileSectionStrip
  }
})
export default class Concejo extends Vue {
  private mediaUrl = process.env.VUE_APP_MEDIA_URL;
  private menu: any = [];
  private menuLateral: any = [];
  private nombreWeb: any = "";
  private concejalesLoading: boolean = false;
  private concejalesError: string = "";
  private listaConcejales: any[] = [];
  private expansibles: any[] = [];

  private beforeMount() {}
  private mounted() {
    document.title = "Concejo Municipal - Municipalidad de Maipú";
    this.setMenu();
    this.setConcejales();
    this.setExpansibles();
  }

  private async setConcejales() {
    this.concejalesLoading = true;
    this.concejalesError = "";

    try {
      const concejales = await concejoMunicipalService.getConcejales();
      this.listaConcejales = this.ensureArray(concejales).map((concejal: any) => ({
        nombre: concejal.nombre,
        email: concejal.correo,
        foto: this.getImagenUrl(concejal.imagen)
      }));
    } catch (error) {
      this.listaConcejales = [];
      this.concejalesError = "No fue posible cargar el Concejo Municipal.";
    } finally {
      this.concejalesLoading = false;
    }
  }

  private ensureArray(value: any) {
    return Array.isArray(value) ? value : [];
  }

  private getImagenUrl(imagen: string) {
    if (!imagen) {
      return `${this.mediaUrl}/bannerPagina/default.jpg`;
    }

    if (/^https?:\/\//.test(imagen)) {
      return imagen;
    }

    return `${this.mediaUrl}/${String(imagen).replace(/^\/+/, "")}`;
  }

  private async setExpansibles() {
    try {
      this.expansibles = this.ensureArray(
        await concejoMunicipalService.getExpansibles()
      );
    } catch (error) {
      this.expansibles = [];
    }
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  private async setMenu() {
    this.menu = await menuService.getMenu();
    for (let i = 0; i < this.menu.length; i++) {
      if (this.getSubMenu(this.menu[i], "concejo-municipal", 1)) {
        this.menuLateral = (this.menu[i] as any).sub_menu;
        this.checkSubMenus();
        break;
      }
    }
  }

  private getSubMenu(element: any, nombre_web: string, profundidad) {
    if (element.nombre_web == nombre_web) {
      return true;
    } else {
      if (element.sub_menu && element.sub_menu.length > 0) {
        for (let j = 0; j < element.sub_menu.length; j++) {
          if (
            this.getSubMenu(element.sub_menu[j], nombre_web, profundidad + 1)
          ) {
            return true;
          }
        }
      }
      return false;
    }
  }

  private selectedStyle(item: any) {
    if (this.isSelectedMenuItem(item)) {
      item.expand = true;
      return " background-color: #10174a !important; color: white !important;font-family: 'RubikBold' !important;";
    }
    return "";
  }

  private isSelectedMenuItem(item: any) {
    if ("concejo-municipal" == item.nombre_web) {
      return true;
    }
    if (item.sub_menu && item.sub_menu.length > 0) {
      for (let i = 0; i < item.sub_menu.length; i++) {
        if ("concejo-municipal" == item.sub_menu[i].nombre_web) {
          return true;
        }
      }
    }
    return false;
  }

  private checkSubMenus() {
    for (let i = 0; i < this.menuLateral.length; i++) {
      if (this.menuLateral[i].sub_menu.length > 0) {
        if (
          this.menuLateral[i].tipo == 2 &&
          "concejo-municipal" == this.menuLateral[i].nombre_web
        ) {
          this.menuLateral[i].expand = true;
        } else {
          for (let j = 0; j < this.menuLateral[i].sub_menu.length; j++) {
            if (
              this.menuLateral[i].sub_menu[j].nombre_web == "concejo-municipal"
            ) {
              this.menuLateral[i].expand = true;
              break;
            }
          }
        }
      } else {
        this.menuLateral[i].expand = false;
      }
    }
  }

  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(item, target == 1 ? "_blank" : "_self");
    } else {
      return;
    }
  }
  private irMenuItem(item: any) {
    if (item.tipo == 1 || item.tipo == 2) {
      this.irPagina(item.nombre_web);
    } else if (item.tipo == 0) {
      this.toLink(item.url, item.blank);
    }
  }
  private irPagina(nombreWeb: any) {
    if (nombreWeb == "contacto") {
      this.routerGo("Contacto");
    } else if (nombreWeb == "concejo-municipal") {
      this.routerGo("Concejo");
    } else {
      if (nombreWeb && nombreWeb != "") {
        if (
          this.$router.currentRoute.name == "Pagina" &&
          this.$router.currentRoute.params.nombre &&
          this.$router.currentRoute.params.nombre == nombreWeb
        ) {
          this.$router.go(0);
        } else {
          if (this.$router.currentRoute.name == "Pagina") {
            if (
              this.$router.currentRoute.params.nombre &&
              this.$router.currentRoute.params.nombre != nombreWeb
            ) {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
              this.$router.go(0);
            } else {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
            }
          } else {
            this.$router
              .push({ name: "Pagina", params: { nombre: nombreWeb } })
              .catch(err => {
                console.log(err);
              });
          }
        }
      }
    }
  }

  private sendMail(correo: string) {
    window.open("mailto:" + correo);
  }
}
